import React, { createContext, useContext, useEffect, useMemo, useState, type ReactNode } from "react";
import { matchPath, useLocation } from "react-router-dom";
import { AvailableBaseRoutes } from "../../utils/constants";

interface IScrollToTopContextType {
  isVisible: boolean;
  setIsVisible: (isVisible: boolean) => void;
}

const IScrollToTopContext = createContext<IScrollToTopContextType>({} as IScrollToTopContextType);

interface IScrollToTopProviderProps {
  children: ReactNode;
}

export const ScrollToTopProvider = (props: IScrollToTopProviderProps) => {
  const value = useScrollToTopProvider();
  return <IScrollToTopContext.Provider value={value}>{props.children}</IScrollToTopContext.Provider>;
};

export const useScrollToTopContext = () => {
  return useContext(IScrollToTopContext);
};

const useScrollToTopProvider = (): IScrollToTopContextType => {
  const [isVisible, setIsVisible] = useState(false);
  const { pathname } = useLocation();

  const isButtonEnabled = useMemo(() => {
    return !!matchPath(pathname, {
      path: AvailableBaseRoutes.GroupDetail,
      exact: true,
    });
  }, [pathname]);

  useEffect(() => {
    setIsVisible(isButtonEnabled);
  }, [isButtonEnabled]);

  return {
    isVisible,
    setIsVisible,
  };
};
